import { FC } from 'react'

import { InterSvgIcon } from 'components'

import { Text } from '@interco/inter-ui/components/Text'
import { Switch } from '@interco/inter-ui/components/Switch'

import { DontDistubMessage } from '../means-of-communication-br/components/mean-of-communication-br/components/dont-distub-message'
import {
  Communication,
  CommunicationIconAndNameContainer,
  Container,
} from '../means-of-communication-br/components/mean-of-communication-br/styles/MeanOfCommunicationBR.styles'

interface MeanOfCommunicationViewProps {
  icon?: string | null
  name: string
  isActive: boolean
  isDisabled: boolean
  isDontDisturb: boolean
  onSwitch: () => void
}

export const MeanOfCommunicationView: FC<MeanOfCommunicationViewProps> = ({
  icon,
  name,
  isActive,
  isDisabled,
  isDontDisturb,
  onSwitch,
}) => (
  <Container>
    <Communication>
      <CommunicationIconAndNameContainer>
        {icon && (
          <InterSvgIcon width={24} height={24} iconRef={icon} color="var(--typography500)" />
        )}
        <Text variant="body-3" color="typography" colorWeight={500} fontWeight={400} as="p">
          {name}
        </Text>
      </CommunicationIconAndNameContainer>
      <Switch disabled={isDisabled} checked={isActive && !isDontDisturb} onClick={onSwitch} />
    </Communication>
    {isDontDisturb && <DontDistubMessage />}
  </Container>
)
